import { Injectable } from '@angular/core';
import { BasePagedCrudService } from "../shared/crud/base-crud.service";
import { HttpClient } from "@angular/common/http";
import { CrudSettings, QueryParams } from "../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../core/environment/environment.service';
import { PravniFormaDto } from './models/PravniFormaDto';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class PravniFormaCrudSettings implements CrudSettings<string, PravniFormaDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'Vse';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: PravniFormaDto) => entity.kod;

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('id', id);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/StrukturaUcetniJednotky/PravniForma';
  }
}

@Injectable({
  providedIn: null
})
export class PravniFormaDataService
  extends BasePagedCrudService<string, PravniFormaDto, PravniFormaDto, PravniFormaDto>{

  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new PravniFormaCrudSettings(environmentService), dialogService);
  }
}
